import { Component, OnInit } from '@angular/core';
import cartitem from '../../../data/cartlist.json';
import { OrderChooserModalService } from '../../../services/order-chooser-modal.service';

@Component({
  selector: 'app-headerthree',
  templateUrl: './headerthree.component.html',
  styleUrls: ['./headerthree.component.css']
})
export class HeaderthreeComponent implements OnInit {

  constructor(private orderChooserModalService: OrderChooserModalService) { }

  openOrderChooser(): void {
    this.orderChooserModalService.open();
  }

  // navigation
  navmethod: boolean = true;
  toggleNav() {
    this.navmethod = !this.navmethod;
  }
  // Cart
  cartmethod: boolean = true;
  cartToggle() {
    this.cartmethod = !this.cartmethod;
  }
  // Search
  searchmethod: boolean = true;
  searchToggle() {
    this.searchmethod = !this.searchmethod;
  }
  // Cart
  public cart: { id: number}[] = cartitem;

  ngOnInit(): void {
  }

}
